// extracted by mini-css-extract-plugin
export var content = "_ok-1";
export var fullScreen = "_ok-0";